export const planner_SET_VIEW_SCHEDULE_SEARCH = 'planner_SET_VIEW_SCHEDULE_SEARCH'

export type TPlannerAction = { type: 'planner_SET_VIEW_SCHEDULE_SEARCH'; searchText: string }

export const setViewScheduleSearchText = (searchText: string): TPlannerAction => ({
    type: planner_SET_VIEW_SCHEDULE_SEARCH,
    searchText,
})
